/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { dailySeriesEntrySchema } from './dailySeriesEntrySchema';

export const dailySeriesResponseSchema = z.object({
  get dailySeries() {
    return z.array(dailySeriesEntrySchema);
  },
});
